import React, { useContext } from "react";

import {TranslationsContext} from "@proxy/_contexts";

export default function OverlayMiddleError() {
  const translations = useContext(TranslationsContext);

  return (
    <div className={"gc__overlay_middle_error_container"}>
      <div className={"gc__permissions_error_message"}>
        <h2 className={"gc__permissions_error_header"}>{ translations.video_recorder_error_heading }</h2>
        <p>{ translations.video_recorder_error_message }</p>
      </div>
    </div>
  );
}
